// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-cengter-dialog[data-v-2758e876]{display:inline-block!important}", ""]);
// Exports
module.exports = exports;
